const prefix = 'auth';

export const AUTHENTICATION_SUCCEEDED = `${prefix}/AUTHENTICATION_SUCCEEDED`;
export const AUTHENTICATION_FAILED = `${prefix}/AUTHENTICATION_FAILED`;
export const AUTHENTICATE = `${prefix}/AUTHENTICATE`;
export const REQUEST_RESET_CODE = `${prefix}/REQUEST_RESET_CODE`;
export const RESET_CODE_SENT = `${prefix}/RESET_CODE_SENT`;
export const RESET_PASSWORD = `${prefix}/RESET_PASSWORD`;

export const SHOW_VERICATION_CODE = `${prefix}/SHOW_VERICATION_CODE`
export const SET_MDN_VALID = `${prefix}/SET_MDN_VALID`
export const RESET_MDN_VALID = `${prefix}/RESET_MDN_VALID`;

export const LOGOUT = `${prefix}/LOGOUT`;
export const LOGOUT_PENDING = `${prefix}/LOGOUT_PENDING`;
export const LOGOUT_SUCCEEDED = `${prefix}/LOGOUT_SUCCEEDED`;
export const LOGOUT_FAILED = `${prefix}/LOGOUT_FAILED`;

export const RESET_STORE = `${prefix}/RESET_STORE`;

export const SET_REDIRECT = `${prefix}/SET_REDIRECT`;

export const CREATE_ADDRESS = `${prefix}/CREATE_ADDRESS`;
export const CREATE_ADDRESS_PENDING = `${prefix}/CREATE_ADDRESS_PENDING`;
export const CREATE_ADDRESS_SUCCEEDED = `${prefix}/CREATE_ADDRESS_SUCCESS`;
export const CREATE_ADDRESS_FAIlED = `${prefix}/CREATE_ADDRESS_FAIlED`;
export const UPDATE_ADDRESS = `${prefix}/UPDATE_ADDRESS`;
export const UPDATE_ADDRESS_PENDING = `${prefix}/UPDATE_ADDRESS_PENDING`;
export const UPDATE_ADDRESS_SUCCEEDED = `${prefix}/UPDATE_ADDRESS_SUCCESS`;
export const UPDATE_ADDRESS_FAIlED = `${prefix}/UPDATE_ADDRESS_FAIlED`;
